
export const WHATSAPP_NUMBER = "5562992213411";
export const COMPANY_EMAIL = "alphamedestetica@gmail.com";
export const LOGO_URL = "https://res.cloudinary.com/dtyszwyp0/image/upload/v1765494131/chrono_kuiper_uploads/rrvpcmfffxpnopq3th1o.webp";